import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EducationLevelsService } from 'src/app/services/educationlevel.service';
import { EducationlevelsModalComponent } from './educationlevels-modal/educationlevels-modal.component';
import { SearchFilterComponent } from '../../shared/search-filter/search-filter.component';
import { PaginationComponent } from '../../shared/pagination/pagination.component';

@Component({
  selector: 'app-educationlevels',
  imports: [CommonModule, SearchFilterComponent, PaginationComponent],
  templateUrl: './educationlevels.component.html',
  styleUrls: ['./educationlevels.component.css']
})
export class EducationLevelsComponent implements OnInit {
  
  constructor(
      private dialog: MatDialog,
      private EducationLevelsService: EducationLevelsService,
      private changeDetectorRef: ChangeDetectorRef
  ) {} 

  
  EducationLevelsList: any[] = [];
  filteredData: any[] = [];
  pagedData: any[] = [];
  pageSize: number = 10;

  ngOnInit(): void {
      this.getEducationLevels();
  }

  getEducationLevels(){
    this.EducationLevelsService.getEducationLevels().subscribe({
      next: (res: any) => {
        this.EducationLevelsList = res;
        this.filteredData = res;
        this.changeDetectorRef.detectChanges();
      },
      error: (err: any) => {
        console.error('Error al cargar niveles formativos:', err);
        this.filteredData = [];
      }
    });
  };

  onPageSizeChange(newSize: number) {
    this.pageSize = newSize;
  }

  openModal(item: any, mode: any, title: any) {
    const dialogRef = this.dialog.open(EducationlevelsModalComponent, {
      data: { item, mode, title },
      maxWidth: '100%',
      width: '40%',
    });
    dialogRef.afterClosed().subscribe({
      next: (res: any) => {
       
        if (!res) return
        if (res) {
          this.getEducationLevels();
        }
      }
    });
  }

}
